import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Teammate, TeammateSearchRequest } from '../models/teammate.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TeammateService {

  constructor(private http: HttpClient) { }

  getTeammateDetails(username: string): Observable<any> {
    return this.http.get<any>(environment.apiUrl + '/teammate/details?username=' + username);
  }

  getTeammateFacilityRoles(username: string): Observable<any> {
    return this.http.get<any>(environment.apiUrl + '/teammate/facility/roles?username=' + username);
  }

  getTeammateInfoFromEDS(username: string): Observable<any> {
    return this.http.get<any>(environment.apiUrl + '/teammate/teammate-info?adUserName=' + username);
  }

  getTeammatesByFacility(facilityNumber: string, size: number, page: number): Observable<any> {
    return this.http.get<any>(environment.apiUrl + '/teammate/by-facility?facilityNumber=' + facilityNumber + '&size=' + size + '&page=' + page);
  }
}
